module.exports = __webpack_public_path__ + "img/public/siteImages/steering.svg?e08cb73c";